import { i18n } from "../../i18n";
import WithRender from "../../templates/containers/uploadContainer.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getShowUpload",
      "getProductPartsNames",
      "getActiveProductPartCode",
      "getProductPartHiddenUploads",
      "getIsMyAccount",
      "getHiddenUploadData"
    ]),
    getProductPartsNamesUploadVisible: function () {
      let hiddenUploads = [];
      if (this.getIsMyAccount) {
        const hiddenUploadData = this.getHiddenUploadData;
        const hasHiddenUpload = parseInt(
          hiddenUploadData?.has_hidden_upload ?? 0
        );
        const hiddenPP = hiddenUploadData?.hidden_product_part ?? "";
        if (hasHiddenUpload && hiddenPP) {
          hiddenUploads.push(hiddenPP);
        }
      } else {
        hiddenUploads = this.getProductPartHiddenUploads(
          this.getActiveProductPartCode
        );
      }

      const initialProductParts = this.getProductPartsNames;
      const productPartsFiltered = this.getProductPartsNames.filter(el => {
        return !hiddenUploads.includes(el.code);
      });
      const productPartsFilteredCodes = productPartsFiltered.map(el => el.code);
      for (let initialProductPart of initialProductParts) {
        if (!productPartsFilteredCodes.includes(initialProductPart.code)) {
          this.$store.dispatch("uploadOnDelete", initialProductPart.code);
        }
      }
      return productPartsFiltered;
    }
  },
  props: ["hideContainer", "alwaysShow"]
});
